// Global Escape-key stack: the most recently opened modal closes first.
// This avoids multiple modals all reacting to the same Escape press.
const escapeHandlers = [];

export function registerEscape(handler) {
  escapeHandlers.push(handler);
  return function unregister() {
    const index = escapeHandlers.indexOf(handler);
    if (index !== -1) escapeHandlers.splice(index, 1);
  };
}

if (typeof document !== "undefined") {
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    if (escapeHandlers.length === 0) return;
    event.preventDefault();
    const top = escapeHandlers[escapeHandlers.length - 1];
    if (typeof top === "function") top();
  });
}
